/**
 * ComplianceHeader - TASK-229
 * Header component with client name and risk level badge
 */

import React from 'react';
import { useRiskRating } from '../../hooks/useCompliance';

interface ComplianceHeaderProps {
  clientName: string;
}

const riskBadgeConfig = {
  low: { color: 'bg-green-100 text-green-800', label: 'LOW RISK' },
  medium: { color: 'bg-yellow-100 text-yellow-800', label: 'MEDIUM RISK' },
  high: { color: 'bg-orange-100 text-orange-800', label: 'HIGH RISK' },
  critical: { color: 'bg-red-100 text-red-800', label: 'CRITICAL RISK' },
} as const;

export const ComplianceHeader: React.FC<ComplianceHeaderProps> = ({ clientName }) => {
  const riskRating = useRiskRating();
  const riskLevel = riskRating?.overall || 'low';
  const badge = riskBadgeConfig[riskLevel];

  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">Compliance</h2>
        <p className="text-sm text-gray-500">{clientName}</p>
      </div>
      <div className="flex items-center gap-4">
        <span className={`px-3 py-1 rounded-full text-sm font-medium ${badge.color}`}>
          {badge.label}
        </span>
      </div>
    </div>
  );
};

export default ComplianceHeader;
